import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { macroImageFailure } from "./macro-import-result";

export const retrySupportMacroImages = {
  name: "retrySupportMacroImages" as const,
  input: z.object({
    teamId: zExt.objectId(),
    macroIds: z.array(z.string()).max(1000),
  }),
  output: z.object({
    copiedCount: z.number(),
    imageFailures: z.array(macroImageFailure).readonly(),
  }),
};
